export const canAutofillPasskeys = async (): Promise<boolean> => {
  if (PublicKeyCredential.isConditionalMediationAvailable) {
    return PublicKeyCredential.isConditionalMediationAvailable();
  }
  return false;
};

export const canUsePasskeys = async (): Promise<boolean> => {
  if (PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable) {
    return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  }
  return false;
};
